import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { State } from '../models/State';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class StateService extends BaseApiService<State> {
  get cacheKey(): StorageKey {
    return StorageKey.stateServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = 'Brasil';
        }
        return `${environment.apiUrl}/regions/${encodeURIComponent(regionId)}/states`;
      default:
        let url = `${environment.apiUrl}/states`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  protected unparse(obj) {
    return State.unparse(obj);
  }

  protected parse(obj) {
    return State.parse(obj);
  }

}
